import { g as o } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as s, openBlock as d, normalizeClass as n, createElementVNode as e } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGoogleSlides",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(l).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], h = /* @__PURE__ */ e("path", {
  d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z",
  fill: "#F4B70A"
}, null, -1), u = /* @__PURE__ */ e("path", {
  d: "M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z",
  fill: "#EFA904"
}, null, -1), f = /* @__PURE__ */ e("path", {
  d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z",
  fill: "#F6C028"
}, null, -1), p = ["fill"], m = /* @__PURE__ */ e("path", {
  d: "m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z",
  fill: "#FADC87"
}, null, -1), g = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5 11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm6.5 2.25H9v3.5h6v-3.5Z",
  fill: "#fff"
}, null, -1), v = ["id"], A = /* @__PURE__ */ e("stop", { "stop-color": "#F4B70A" }, null, -1), S = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#E2930A"
}, null, -1), I = [
  A,
  S
];
function Z(a, b, i, q, C, t) {
  return d(), s("svg", {
    "aria-label": i.ariaLabel,
    class: n([t.iconSizeClass, "d-icon d-icon--google-slides"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Google Slides",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    h,
    u,
    f,
    e("path", {
      d: "M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z",
      fill: `url(#${a.uniqueID}a)`
    }, null, 8, p),
    m,
    g,
    e("defs", null, [
      e("linearGradient", {
        id: `${a.uniqueID}a`,
        x1: "17.265",
        y1: "12.125",
        x2: "17.265",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      }, I, 8, v)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ r(c, [["render", Z]]);
export {
  w as default
};
//# sourceMappingURL=google-slides.js.map
